import { apiFetch, getApiUrl } from './client';

export interface User {
  username: string;
  displayName?: string;
  email?: string;
  avatar?: string;
  role?: string;
}

export async function fetchMe(): Promise<User> {
  return apiFetch('/v1/auth/me');
}

export function loginUrl(next = ''): string {
  const params = new URLSearchParams();
  if (next) params.set('next', next);
  return getApiUrl(`/v1/auth/login?${params.toString()}`);
}

export async function logout(): Promise<void> {
  await apiFetch('/v1/auth/logout', { method: 'POST' });
}
